import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem } from '@mui/x-data-grid';

const AGENT_COLUMNS = handleEdit => [
  {
    field: 'agentNum',
    headerName: 'Número',
    maxWidth: 100,
    type: 'number',
  },
  {
    field: 'agentName',
    headerName: 'Nombre',
    flex: 4,
    minWidth: 200,
  },
  {
    field: 'plazas',
    headerName: 'Plazas',
    flex: 1,
    minWidth: 200,
    align: 'center',
    headerAlign: 'center',
    valueGetter: params =>
      params.row.plazas.map(plaza => plaza.plazaName).join(', '),
  },
  {
    field: 'isActive',
    headerName: 'Activo',
    type: 'boolean',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Acciones',
    flex: 1,
    minWidth: 100,
    align: 'center',
    getActions: params => [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="Editar"
        onClick={() => handleEdit(params)}
      />,
    ],
  },
];

export default AGENT_COLUMNS;
